import React, {ReactElement} from "react";
import PromoCodeIcon from "../../assets/logo/PromoCodeIcon";
import {SmartPricingRule} from "../../services/exports/Interfaces";

interface Props {
  data: SmartPricingRule;
}

export default function SmartPricingDeal({ data }: Props): ReactElement {
  return (
    <div className="bg-brand-primary/[.125] p-xsmall rounded-md">
      <div className="p-xmini flex bg-brand-primary w-fit rounded">
        <PromoCodeIcon className="h-3 w-3 mr-tiny my-auto" color="white" />
        <h6 className="my-auto text-white text-mini">Deal</h6>
      </div>
      <p className="font-bold text-mini text-brand-primary mt-mini">{data.name}</p>
    </div>
  )
};